import React from "react";
import { i18n } from "../../translate/i18n";
import { Avatar, CardHeader, Grid, makeStyles } from "@material-ui/core";

const useStyles = makeStyles(theme => ({
	cardHeader: {
		padding: "8px 8px",
		flex: 1,
		minWidth: 0,
		"& .MuiCardHeader-avatar": {
			marginRight: 12,
		},
		"& .MuiCardHeader-title": {
			fontSize: "0.95rem",
			fontWeight: 600,
			color: theme.mode === "light" ? "#0f172a" : "#f1f5f9",
			letterSpacing: "0.01em",
		},
		"& .MuiCardHeader-subheader": {
			fontSize: "0.75rem",
			color: theme.mode === "light" ? "#64748b" : "#94a3b8",
			marginTop: 2,
		},
		[theme.breakpoints.down("sm")]: {
			padding: "4px 6px",
			"& .MuiCardHeader-avatar": {
				marginRight: 8,
			},
			"& .MuiCardHeader-title": {
				fontSize: "0.82rem",
			},
			"& .MuiCardHeader-subheader": {
				fontSize: "0.68rem",
				marginTop: 1,
			},
		},
	},
	avatar: {
		width: 42,
		height: 42,
		border: `2px solid ${theme.mode === "light" ? "rgba(148,163,184,0.25)" : "rgba(148,163,184,0.35)"}`,
		boxShadow: theme.mode === "light" ? "0 2px 8px rgba(15,23,42,0.1)" : "0 2px 8px rgba(0,0,0,0.3)",
		[theme.breakpoints.down("sm")]: {
			width: 32,
			height: 32,
		},
	},
}));

const TicketInfo = ({ contact, ticket, onClick }) => {
	const classes = useStyles();

	const renderCardReader = () => {
		return (
			<CardHeader
				onClick={onClick}
				className={classes.cardHeader}
				style={{ cursor: "pointer" }}
				titleTypographyProps={{ noWrap: true }}
				subheaderTypographyProps={{ noWrap: true }}
				avatar={<Avatar src={contact?.urlPicture} alt="contact_image" className={classes.avatar} />}
				title={`${contact?.name || '(sem contato)'} #${ticket.id}`}
				subheader={
					ticket.user &&
					`${i18n.t("messagesList.header.assignedTo")} ${ticket.user.name}`
				}
			/>
		);
	}


	return (
		<React.Fragment>
			<Grid container alignItems="center" style={{ flex: 1, minWidth: 0 }}>
				<Grid item style={{ flex: 1, minWidth: 0 }}>
					{renderCardReader()}
				</Grid>
			</Grid>
		</React.Fragment>
	);
};

export default TicketInfo;
